<template>
  <div class="account-row system-settings">
    <div class="heading">
      <h2>{{$ml.get(`System settings`)}}</h2>

      <!-- <app-btn
        @click="save"
      >{{ $ml.get(`save`) }}</app-btn> -->
    </div>
    <form>
      <!-- {{userCurrency}} -->
      <app-sel
        filterable
        :label="$ml.get('Currency')"
        :items="currencies"
        key-name="code"
        label-name="name"
        class="text-input user-sel"
        :value="userCurrency.code ? userCurrency.code : 'USD'"
        @input="saveCurrency"
      >
        <template v-slot="{ items }">
          <app-sel-opt v-for="item in items" :value="item" :key="item.key">
            {{$ml.get(item.name)}} ({{item.symbol}})
          </app-sel-opt>
        </template>
      </app-sel>


      <app-sel
        :value="currentLang.locale"
        :label="language.label+' (Language)'"
        :items="languages"
        label-name="fullName"
        key-name="locale"
        @input="saveLang"
        v-if="currentLang"
        class="text-input user-sel"
      >
        <template v-slot="{ items }">
          <app-sel-opt v-for="item in items" :value="{locale: item}" :key="item.locale">
            {{ item.fullName }}
          </app-sel-opt>
        </template>
      </app-sel>



      <app-sel
        v-if="$store.getters['user/data'].globalRole == 'admin'"
        :value="targetMetric"
        :label="$ml.get('Units')"
        :items="metrics.map(item => {return {label: item}})"
        label-name="label"
        key-name="label"
        @input="saveMetric"
        class="text-input user-sel"
      >
        <template v-slot="{ items }">
          <app-sel-opt v-for="item in items" :value="{label: item}" :key="item.label">
            {{  (item.label.toLowerCase() == 'us') ? 'US' : 'Metric' }}
          </app-sel-opt>
        </template>
      </app-sel>

    </form>

  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    data : {
      required: true
    }
  },
  data () {
    return {
      currency: 'USD',
      units: [
        {
          key: 'Us'
        },
        {
          key: 'Metric'
        }
      ],
      flag: 0,
      language: {
        label: this.$ml.get(`Language`),
      },
    }
  },
  methods : {
    saveMetric (val) {
      this.$store.dispatch('unit/setTarget', val.label);
    },
    saveCurrency(code) {
      return API.user.saveCurrency(code)
        .then(res => {
          // console.log(res.data);
          this.$store.dispatch('user/updateData');
        })
    },
    saveLang(lang) {
      console.log(lang)
      let request = {
        language : lang.locale,
        // dateFormat : this.data.dateFormat.value,
        // currency : this.data.currency.value,
        // units : this.data.units.value,
      };

      this.$ml.change(lang.locale);
      this.$store.commit('user/setLanguage', lang.locale);

      return API.user.updateSystemSettings(request).then(res => {
        if(res.data.success) {
          // this.$notify({
          //   group: 'notices',
          //   title: this.$ml.get(`Your data was successfully updated!`),
          //   type : 'success',
          // });
          location.reload();
        }
      }).catch(err => {
        // this.$notify({
        //   group: 'notices',
        //   title: `Error! "${err.response.data.err}"`,
        //   type : 'error',
        // });
      });
    },
    changeUnits(units) {
      return API.user.changeUnits(units).then(res => {
        cpnsole.log(res)
      })
    }
  },
  computed: {
    currentLang() {
      return this.languages.find(x => x.locale == this.$store.getters['user/data'].language);
    },
    // languages() {
    //   return this.$store.getters['misc/getLanguagesValue'];
    // },
    ...mapGetters({
      currencies : 'misc/currencies',
      languages: 'misc/getLanguagesValue',
      userCurrency: 'user/currency',
      metrics: 'unit/types',
      user: 'user/data',
      targetMetric: 'unit/target',
    })
  },
  created () {
    this.$store.dispatch('misc/loadCurrencies');
    this.$store.dispatch('misc/loadLanguages');

    // console.log(this.languages);
  }
}
</script>

<style lang="scss" scoped>
  .system-settings {
    .user-sel {
      margin-bottom: 24px;
    }
  }
</style>
